import {useState, useRef, useEffect} from "react";
import CountUp from 'react-countup';

const CounterUpItem = ({ data }) => {
    const [didViewCountUp, setDidViewCountUp] = useState(false);
    const countUpRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setDidViewCountUp(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (countUpRef.current) {
            observer.observe(countUpRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div className="funfact" ref={countUpRef}>
            <div className="number">
                <CountUp end={didViewCountUp ? data.number : 0} />
            </div>
            <h6 className="text">{data.text}</h6>
        </div>
    )
}

export default CounterUpItem;
